import React, { useState } from 'react';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutlineNew.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import BlueCheckBox from 'src/assets/images/BlueCheckBox.svg';
import { useSelector } from 'react-redux';
import {
    Text,
    ManualEntryDiv,
    ManualButtonContainer,
    ManualSetsDiv,
    ConfirmationDiv,
} from './index.styled';
import { useTranslation } from 'react-i18next';
import { TITLE_FONT_COLOR } from 'src/styles/fonts/MCFontConstants';
import { logErrorToConsole } from 'src/utils/util';

const SetsManualEntry = ({ onClose, onDiscard, onSubmit }) => {
    const [checked, setChecked] = useState(false);
    const checkBoxHandler = () => {
        setChecked(!checked);
    };
    const setsOutsideTerritoryList = useSelector(
        (state) => state.receiveSetsListDataReducer.setsOutsideTerritoryList
    );
    const { t } = useTranslation();
    return (
        <>
            <Popup
                title={t(
                    'receiveSets.ReceiveSetsLoc.AddSetsLists.manualEntryOfSetsFromAnother'
                )}
                onClose={onClose}
                img={AlertCircleOutline}
                width={'100%'}
                mobileMargin={'0 20px'}
                alignItemsMob={'flex-start'}
                borderRadius={'6px'}
                popupContentPadding={'15px 20px 10px'}
                lineHeight={'25px'}
                mbIconWidth={'25px'}
                color={'#140F4B'}
                id={'receiveSets-setsManualEntry-popup'}
            >
                <ManualEntryDiv divHeight={'140px'}>
                    <ManualSetsDiv isChecked={checked}>
                        <ConfirmationDiv
                            style={{ display: 'flex', paddingTop: '10px' }}
                        >
                            <Checkbox
                                checked={checked}
                                onCheckboxSelectionChange={checkBoxHandler}
                                id="receiveSets-ReceiveSetsLoc-SetsManualEntry-checkbox"
                                margin={'0 0 10px 10px'}
                                background={'none'}
                                checkedBgColor={TITLE_FONT_COLOR}
                                checkboxBorder={'1.5px solid #555555'}
                                alignItemDirection={'baseline'}
                                hoverEffect={'false'}
                                disableFocusEffect={'true'}
                            />
                            <Text
                                flexGrow={'1'}
                                height={'auto'}
                                font={'14px Avenir Next World'}
                                lineHeight={'22px'}
                                paddingLeft={'10px'}
                            >
                                {t(
                                    'receiveSets.ReceiveSetsLoc.AddSetsLists.iHaveConfirmedTheInformation'
                                )}{' '}
                                <span
                                    style={{
                                        fontFamily: 'AVENIRNEXTWORLD DEMI',
                                    }}
                                >
                                    {setsOutsideTerritoryList?.length}{' '}
                                    {t('common.setsLowerCaseLabel')}
                                </span>{' '}
                                {t(
                                    'receiveSets.ReceiveSetsLoc.AddSetsLists.manuallyEnteredIsAccurate'
                                )}
                            </Text>
                        </ConfirmationDiv>
                    </ManualSetsDiv>
                    <ManualButtonContainer>
                        <Button
                            id={'receiveSets-SetsManualEntry-review-button'}
                            show={true}
                            //cancel={true}
                            variant={ButtonStyles?.cancel}
                            width={'102px'}
                            height={'38px'}
                            // borderRadius={'19px'}
                            margin={'5px 0 5px 5px'}
                            // fontSize={'15px'}
                            // fontFamily={'AvenirNextWorld Demi'}
                            clicked={onDiscard}
                        >
                            <div style={{ whiteSpace: 'nowrap' }}>
                                {t(
                                    'reportUsage.reportUsageFooterbuttons.reviewButton'
                                )}
                            </div>
                        </Button>
                        <Button
                            id={'receiveSets-SetsManualEntry-submit-button'}
                            show={true}
                            width={'121px'}
                            height={'38px'}
                            // primary={checked ? true : false}
                            disabled={checked ? false : true}
                            variant={checked ? ButtonStyles?.primary : ButtonStyles?.disabled}
                            borderRadius={'19px'}
                            margin={'5px 0 5px 5px'}
                            // fontSize={'15px'}
                            // fontFamily={'AvenirNextWorld Demi'}
                            clicked={() => {
                                try {
                                onSubmit();
                                onDiscard();
                                 } catch (error) {
                                    logErrorToConsole(error);
                                  }
                            }}
                        >
                            <div style={{ whiteSpace: 'nowrap' }}>
                                {t('reportUsage.progressBar.submit')}
                            </div>
                        </Button>
                    </ManualButtonContainer>
                </ManualEntryDiv>
            </Popup>
        </>
    );
};

export default SetsManualEntry;
